// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__jmXtJ","container":"Footer_container__iICw7","spacer":"Footer_spacer__z9AML"};